export default __webpack_public_path__ + "static/media/hht1_ep09_timeline_q01_b.356e06a5.png";